import * as z from "zod/v4";

export const removeTeamFromFeatureFlag = {
  name: "removeTeamFromFeatureFlag" as const,
  input: z.object({
    flagKey: z.string(),
    environmentKey: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
